export default __webpack_public_path__ + "static/media/drone.8105fa2f.png";